import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import LayoutGap from "%/dynamic-components/render-engine/options/layout-options/layout-gap";
import Overflow from "%/dynamic-components/render-engine/options/layout-options/overflow";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import MaxHeight from "%/dynamic-components/render-engine/options/spacing-options/max-height";
import MinHeight from "%/dynamic-components/render-engine/options/spacing-options/min-height";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import LayoutWrap from "%/dynamic-components/render-engine/options/layout-options/layout-wrap";
import ScrunchWhenSqueezed from "%/dynamic-components/render-engine/options/layout-options/scrunch-when-squeezed";
import StaticLayoutDirection from "%/dynamic-components/render-engine/options/layout-options/static-layout-direction";
import LayoutAlign from "%/dynamic-components/render-engine/options/layout-options/layout-align";
import LayoutAlignVertical from "%/dynamic-components/render-engine/options/layout-options/layout-align-vertical";
import ScaleWidthAnchor from "%/dynamic-components/render-engine/options/layout-options/scale-width-anchor";

export default class LayoutPositionOptions extends BaseOptionsBundle {
  optionTitle = "Layout";
  inspectorToolGroup = "layout";
  useInspectorLabel = false;
  static optionClassName = "i-dynamic-layout-position";
  static userInterfaceComponent = {
    component: inspectorTools.LAYOUT_POSITION_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      LayoutWidth,
      MaxWidth,
      MaxHeight,
      MinHeight,
      MinWidth,
      LayoutHeight,
      StaticLayoutDirection,
      LayoutAlign,
      LayoutAlignVertical,
      Overflow,
      LayoutGap,
      LayoutWrap,
      ScrunchWhenSqueezed,
      ScaleWidthAnchor,
    ]);
  }
}
